import type { ImportedInvalidClient } from '@/types/clientDetailsApiTypes';

interface InvalidTableProps {
  rows: ImportedInvalidClient[];
}

export function InvalidTable({ rows }: InvalidTableProps) {
  if (!rows.length) return null;
  return (
    <table className="w-full min-w-[520px] border-collapse table-fixed">
      <colgroup>
        <col style={{ width: '44px' }} />
        <col style={{ width: '100px' }} />
        <col style={{ width: '100px' }} />
        <col style={{ width: '100px' }} />
        <col />
      </colgroup>
      <thead className="bg-grey-100">
        <tr className="border-b border-grey-300">
          <th className="text-left py-3 pl-3 pr-1.5 font-inter text-[12px] font-medium leading-[150%] text-grey-700">
            Row
          </th>
          <th className="text-left py-3 px-1.5 font-inter text-[12px] font-medium leading-[150%] text-grey-700 whitespace-nowrap">
            First name
          </th>
          <th className="text-left py-3 px-1.5 font-inter text-[12px] font-medium leading-[150%] text-grey-700 whitespace-nowrap">
            Last name
          </th>
          <th className="text-left py-3 px-1.5 font-inter text-[12px] font-medium leading-[150%] text-grey-700">
            Email
          </th>
          <th className="text-left py-3 px-1.5 font-inter text-[12px] font-medium leading-[150%] text-grey-700">
            Issue
          </th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={i} className="border-b border-grey-300 last:border-0">
            <td className="py-4 pl-3 pr-1.5 text-body-small text-black align-top">{i + 1}</td>
            <td className="py-4 px-1.5 text-body-small text-black align-top break-words">{r.data.first_name ?? '—'}</td>
            <td className="py-4 px-1.5 text-body-small text-black align-top break-words">{r.data.last_name ?? '—'}</td>
            <td className="py-4 px-1.5 text-body-small text-black align-top truncate">{r.data.email ?? '—'}</td>
            <td className="py-4 px-1.5 align-top">
              <div className="flex flex-wrap gap-1">
                {Object.entries(r.errors).map(([field, msgs]) => (
                  <span
                    key={field}
                    className="py-0.5 pl-2 pr-0.5 rounded-[6px] bg-red-500/10 text-red-500 font-inter text-[12px] font-normal leading-[18px]"
                  >
                    {msgs.join(', ')}
                  </span>
                ))}
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
